import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
} from "@angular/core";
import {
  provideRouter,
  withPreloading,
  PreloadAllModules,
} from "@angular/router";
import { provideAnimations } from "@angular/platform-browser/animations";
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { routes } from "./app-routing.module";
import {
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalService,
  MsalModule,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
} from "@azure/msal-angular";
import {
  MSALGuardConfigFactory,
  MSALInstanceFactory,
  MSALInterceptorConfigFactory,
} from "./msal.setup";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { LessonRoutingGuard } from "./core/services/lesson-routing-guard.service";
import { UserService } from "./core/http/user.service";
import { LessonService } from "./core/http/lesson.service";
import { LessonVotingService } from "./core/services/lesson-services/lesson-voting-service";
import { FlaggingLessonService } from "./core/http/flagging-lesson.service";
import { LessonErrorHandler } from "./core/interceptors/error-handler.interceptor";
import { TokenInterceptor } from "./core/interceptors/http.token.interceptor";
import { ErrorDialogService } from "./shared/components/error-dialog/error-dialog.service";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(MsalModule),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { floatLabel: "never", appearance: "outline" },
    },
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory },
    { provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    { provide: ErrorHandler, useClass: LessonErrorHandler },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    LessonRoutingGuard,
    UserService,
    LessonService,
    LessonVotingService,
    FlaggingLessonService,
    ErrorDialogService,
  ],
};
